function GradientText({className, children, style}) {
    return (
        <span style={style} className={`max-w-fit bg-gradient-to-br from-cblue to-cgreen bg-clip-text text-transparent font-bold ${className}`}>{children}</span>
    );
}

export default GradientText;